export default __webpack_public_path__ + "static/media/Macro2_anchor_spacing_x.deb249da.png";